import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  background: #fff;
  position: relative;
  z-index: 200;
`;

export const Content = styled.div`
  height: 130px;
  max-width: 1068px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Left = styled.div`
  width: 30%;
`;
export const Right = styled.div`
  width: 68%;
  height: 80px;
  nav {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #79a02e;
      align-self: center;
    }
    ul li a {
      font-size: 10px;
      font-weight: bold;
      font-stretch: normal;
      margin-left: 15px;
      color: #235f6e;
      :first-child {
        font-size: 11px;
      }
      :last-child {
        font-weight: normal;
      }
    }
  }
`;

export const BoxSearch = styled.div`
  margin-top: 35px;
  display: flex;
  justify-content: flex-end;

  form {
    input {
      background: #ffffff;
      border: 0;
      border-radius: 4px;
      width: 320px;
      height: 30px;
      padding: 0 15px;
      color: #282828;
      margin: 0 0 0 0;
      box-shadow: inset 0px 1px 0px 0px #c7c7c794;

      border: solid 0.5px #c7c7c794;

      &::placeholder {
        font-size: 10.2px;
        font-weight: 500;
        font-style: normal;

        color: #999999;
      }
    }
    button {
      background: #74a50a;
      width: 74px;
      height: 30px;
      margin-left: 15px;
      border-radius: 3.5px;
      color: #fff;
      border: 0;
      font-size: 13px;
      transition: background 0.2s;
      &:hover {
        background: ${darken(0.03, '#74a50a')};
      }
    }
  }
`;

export const BoxNavBar = styled.div`
  width: 100%;
  height: 3.9em;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-image: linear-gradient(to bottom, #3f8da1, #0a728a);
  display: flex;
  align-items: center;

  p.title {
    font-size: 16px;
    font-stretch: normal;
    font-style: normal;
    font-weight: bold;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #ffffff;
    margin: 0 auto;
  }
`;

export const PageTitle = styled.div`
  margin: 30px auto 0 auto;
  width: auto;
  max-width: 1068px;
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
`;
